import * as React from 'react';

function SvgPhoneVibrate(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M10 3a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h4zM6 2a2 2 0 00-2 2v8a2 2 0 002 2h4a2 2 0 002-2V4a2 2 0 00-2-2H6z' />
			<path d='M8 12a1 1 0 100-2 1 1 0 000 2zM1.599 4.058a.5.5 0 01.208.676A6.967 6.967 0 001 8c0 1.18.292 2.292.807 3.266a.5.5 0 01-.884.468A7.968 7.968 0 010 8c0-1.347.334-2.619.923-3.734a.5.5 0 01.676-.208zm12.802 0a.5.5 0 01.676.208A7.967 7.967 0 0116 8a7.967 7.967 0 01-.923 3.734.5.5 0 01-.884-.468A6.967 6.967 0 0015 8c0-1.18-.292-2.292-.807-3.266a.5.5 0 01.208-.676zM3.057 5.534a.5.5 0 01.284.648A4.986 4.986 0 003 8c0 .642.12 1.255.34 1.818a.5.5 0 11-.93.364A5.986 5.986 0 012 8c0-.769.145-1.505.41-2.182a.5.5 0 01.647-.284zm9.886 0a.5.5 0 01.648.284C13.855 6.495 14 7.231 14 8c0 .769-.145 1.505-.41 2.182a.5.5 0 01-.93-.364C12.88 9.255 13 8.642 13 8c0-.642-.12-1.255-.34-1.818a.5.5 0 01.283-.648z' />
		</svg>
	);
}

export default SvgPhoneVibrate;
